import useAuth from 'hooks/useAuth';
import { usePermissions } from 'hooks/usePermissions';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function PermissionGuard({ children, permissions = [], roles = [], requireAll = false }) {
  const { isLoggedIn, isInitialized } = useAuth();
  const { hasAnyPermission, hasAllPermissions, hasAnyRole } = usePermissions();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  //console.log('[PermissionGuard] Checking permissions for', { permissions, roles, requireAll });

  useEffect(() => {
    if (!isInitialized) return; // ← esperar a que auth termine
    setChecking(true);

    if (!isLoggedIn) {
      navigate('/login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
      setChecking(false);
      return;
    }

    // Permission validation
    const hasValidPermission = permissions.length ? (requireAll ? hasAllPermissions(permissions) : hasAnyPermission(permissions)) : true;

    // Role validation
    const hasValidRole = roles.length ? hasAnyRole(roles) : true;

    if (!hasValidPermission || !hasValidRole) {
      navigate('/maintenance/403', { replace: true });
      setChecking(false);
      return;
    }

    setChecking(false);
  }, [isLoggedIn, isInitialized, permissions, roles, requireAll, hasAnyPermission, hasAllPermissions, hasAnyRole, navigate, location]);

  if (!isInitialized || checking) return null; // Or a loading spinner if desired

  return children;
}
